import type { ReactNode } from 'react';

export const symbol_spellcheck: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m563-164 219-219q9-9 21-9t21 9q9 9 9 21t-9 21L605-122q-9 9-20 13t-22 4q-11 0-22-4t-20-13l-96-96q-9-9-9-21t9-21q9-9 21-9t21 9l96 96ZM238-454l-47 123q-3 9-11 14t-17 5q-16 0-24.5-13t-3.5-28l177-466q4-9 11.5-14.5T341-839h24q10 0 17.5 5.5T394-819l176 465q6 15-3 28.5T541-312q-10 0-18-5.5T511-332l-46-122H238Zm19-58h189l-92-254h-5l-92 254Z"
		/>
	</svg>
);
